const initState = null;

const viewAgentId = (state = initState, action) => {
    switch (action.type) {
        case 'SET_VIEW_AGENT_ID':
            state = action.agentId;            
            return state;
        default: return state;
    }
};

export default viewAgentId;